<div class="profile-image-container w-100 h-100">
    <div class="modal-content-container px-sm-1 p-md-5 d-flex justify-content-center">
        <div class="back-btn">
            <i (click)="backBtn()" *ngIf="stepChangeImage === stepChangeImageOptions.CROP_IMAGE"
               class="pi pi-arrow-left cursor-pointer"></i>
        </div>
        <a id="close-dialog-alta" class="close-dialog" (click)="closeDialog()">
            <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
        </a>
        <div class="step-1" *ngIf="stepChangeImage === stepChangeImageOptions.CHANGE_IMAGE">
            <div class="avatar text-center">
                <p-avatar *ngIf="!this.userInfo['userImage']" [label]="calculateInitials()" styleClass="mr-2"
                          [style]="{ 'background-color': '#001865', color: '#ffffff' }"
                          [className]="'avatar-with-background cursor-pointer'"
                          shape="circle"
                          size="large">

                </p-avatar>
                <p-avatar
                        *ngIf="this.userInfo['userImage']"
                        [image]="this.userInfo['userImage']"
                        [className]="'avatar-with-background'"
                        styleClass="avatar mr-2 cursor-pointer avatar-with-background"
                        size="large"
                        shape="circle"
                >
                </p-avatar>
            </div>
            <div class="title mt-1">
                {{'changeProfilePhoto.step1.title' | translate}}
            </div>
            <div class="message w-100 text-center mt-2">
                {{'changeProfilePhoto.step1.message' | translate}}
            </div>
            <div class="change-image-btn mt-3 text-center">
                <button (click)="uploadImageStep()"
                        class="btn btn-primary">{{'changeProfilePhoto.step1.btn' | translate}}</button>
            </div>
        </div>
        <div class="step-2" *ngIf="stepChangeImage === stepChangeImageOptions.UPLOAD_IMAGE">
            <div class="change-photo-container text-center">
                {{'changeProfilePhoto.step2.title' | translate}}
            </div>
            <div class="file-upload-container text-center d-flex align-items-center mt-3"
                 (drop)="onDrop($event)" (dragover)="onDragOver($event)">
                <div>
                    <div class="file-icon-container">
                        <img src="assets/icons/Upload_Outline.png">
                    </div>
                    <div class="label-upload-container mt-2 text-center ">
                        <p>{{'changeProfilePhoto.step2.dragDropMessage' | translate}}</p>
                    </div>
                </div>
            </div>
            <div class="text-center mt-2">{{'changeProfilePhoto.step2.o' | translate}}</div>
            <div class="upload-btn-container d-flex justify-content-center text-center mt-2">
                <input (change)="onFileSelected($event)" type="file" id="files" class="hidden"
                       style="display: none" accept=".png, .jpg, .jpeg"/>
                <label class="btn btn-primary d-flex justify-content-center align-items-center" style="width: 200px"
                       for="files">{{'changeProfilePhoto.step2.selectFileBtn' | translate}}</label>
            </div>
        </div>
        <div class="step-3" *ngIf="stepChangeImage === stepChangeImageOptions.CROP_IMAGE">
            <div class="change-photo-container text-center">
                {{'changeProfilePhoto.step3.title' | translate}}
            </div>
            <image-cropper
                    [imageChangedEvent]="imageChangedEvent"
                    [maintainAspectRatio]="true"
                    [aspectRatio]="1 / 1"
                    [roundCropper]="true"
                    [backgroundColor]="'red'"
                    format="png"
                    [imageBase64]="imageUrl"
                    (imageCropped)="imageCropped($event)"
                    (imageLoaded)="imageLoaded($event)"
                    (cropperReady)="cropperReady()"
                    (loadImageFailed)="loadImageFailed()"
            ></image-cropper>
            <div class="update-btn-container text-center mt-2">
                <button class="btn btn-primary m-auto" type="button" [disabled]="loading"
                        (click)="cropImage()">
                    <span *ngIf="!loading">{{'changeProfilePhoto.step3.updateBtn' | translate}}</span>
                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                    <span *ngIf="loading" role="status">{{'changeProfilePhoto.loading'|translate}}</span>
                </button>
            </div>
        </div>

    </div>
</div>
